// Ficha de producto SRJ: galería, cantidad, cuenta regresiva de entrega, "Comprar ahora" y preguntas frecuentes.
(function () {
  function iniciar(ficha) {
    if (ficha.dataset.srjListo) return;
    ficha.dataset.srjListo = '1';

    // Galería: la miniatura elegida pasa a la imagen principal.
    var imagenes = ficha.querySelectorAll('.srj-ficha__imagen');
    var minis = ficha.querySelectorAll('.srj-ficha__mini');
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var i = mini.dataset.indice;
        imagenes.forEach(function (img) { img.classList.toggle('is-activa', img.dataset.indice === i); });
        minis.forEach(function (m) {
          var activa = m === mini;
          m.classList.toggle('is-activa', activa);
          if (activa) m.setAttribute('aria-current', 'true'); else m.removeAttribute('aria-current');
        });
      });
    });

    // Elegir una foto (desde una miniatura, deslizando la principal o al cerrar el visor)
    var mostrar = function (i) {
      var s = String(i);
      imagenes.forEach(function (img) { img.classList.toggle('is-activa', img.dataset.indice === s); });
      minis.forEach(function (m) {
        var activa = m.dataset.indice === s;
        m.classList.toggle('is-activa', activa);
        if (activa) m.setAttribute('aria-current', 'true'); else m.removeAttribute('aria-current');
      });
    };
    var activaActual = function () {
      var a = ficha.querySelector('.srj-ficha__imagen.is-activa');
      return a ? parseInt(a.dataset.indice, 10) : 0;
    };

    // Deslizar la foto principal de costado en táctil (el scroll vertical sigue siendo de la página)
    var principal = ficha.querySelector('.srj-ficha__principal');
    var total = imagenes.length;
    var toque = null, deslizoEn = 0;
    if (principal && total > 1) {
      principal.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { toque = null; return; }
        toque = { x: e.touches[0].clientX, y: e.touches[0].clientY, t: Date.now() };
      }, { passive: true });
      principal.addEventListener('touchend', function (e) {
        if (!toque) return;
        var dx = e.changedTouches[0].clientX - toque.x, dy = e.changedTouches[0].clientY - toque.y;
        toque = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        deslizoEn = Date.now();
        mostrar((activaActual() + (dx < 0 ? 1 : -1) + total) % total);
      }, { passive: true });
    }

    // Visor a pantalla completa
    var visor = ficha.querySelector('[data-srj-visor]');
    if (visor && principal && typeof visor.showModal === 'function') {
      var pista = visor.querySelector('[data-srj-visor-pista]');
      var fotos = pista.querySelectorAll('img');
      var numeroVisor = visor.querySelector('[data-srj-visor-n]');
      var ant = visor.querySelector('[data-srj-visor-ant]');
      var sig = visor.querySelector('[data-srj-visor-sig]');
      var cargar = function (i) {
        var img = fotos[i];
        if (img && img.dataset.src) {
          img.srcset = img.dataset.srcset; img.src = img.dataset.src;
          delete img.dataset.src; delete img.dataset.srcset;
        }
      };
      var actual = 0;
      var indiceVisor = function () { return Math.round(pista.scrollLeft / Math.max(1, pista.clientWidth)); };
      var actualizar = function () {
        if (!visor.open) return;
        var i = Math.min(fotos.length - 1, Math.max(0, indiceVisor()));
        actual = i;
        numeroVisor.textContent = i + 1;
        cargar(i); cargar(i + 1); cargar(i - 1);
        if (ant) ant.disabled = i === 0;
        if (sig) sig.disabled = i === fotos.length - 1;
      };
      var ir = function (i, suave) {
        pista.scrollTo({ left: i * pista.clientWidth, behavior: suave ? 'smooth' : 'auto' });
      };
      var abrir = function (i) {
        cargar(i); cargar(i + 1); cargar(i - 1);
        document.body.classList.add('overflow-hidden');
        visor.showModal();
        ir(i, false);
        actualizar();
      };
      principal.addEventListener('click', function () {
        // un deslizamiento recién hecho no abre el visor (el navegador a veces manda un clic al soltar)
        if (Date.now() - deslizoEn < 500) return;
        abrir(activaActual());
      });
      pista.addEventListener('scroll', function () { window.requestAnimationFrame(actualizar); }, { passive: true });
      if (ant) ant.addEventListener('click', function () { ir(indiceVisor() - 1, true); });
      if (sig) sig.addEventListener('click', function () { ir(indiceVisor() + 1, true); });
      visor.querySelector('[data-srj-visor-cerrar]').addEventListener('click', function () { visor.close(); });
      visor.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); ir(indiceVisor() + 1, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); ir(indiceVisor() - 1, true); }
      });
      // Tocar el fondo negro (no la foto ni los botones) también cierra
      visor.addEventListener('click', function (e) {
        if (e.target === visor || e.target.classList.contains('srj-visor__foto')) visor.close();
      });
      visor.addEventListener('close', function () {
        document.body.classList.remove('overflow-hidden');
        mostrar(actual);
      });
    }

    // Piso SPC: m² que pide el cliente -> m² al carrito (con 10% para cortes, redondeado para arriba), total y cajas de referencia
    var m2 = ficha.querySelector('[data-srj-m2]');
    if (m2) {
      var m2Num = m2.querySelector('.srj-cantidad__numero');
      var m2Margen = m2.querySelector('[data-srj-m2-margen]');
      var m2Cant = m2.querySelector('[data-srj-m2-cantidad]');
      var m2Precio = parseInt(m2.dataset.precio, 10) / 100;
      var m2Caja = parseFloat(m2.dataset.caja);
      // WPC interior (data-modo="piezas"): se piden paneles; el ancho de la pared calcula cuántos
      if (m2.dataset.modo === 'piezas') {
        // Caja cerrada (Ronald, 20/10/2026): "Por unidad" agrega el panel; "Caja cerrada" agrega la caja (paquete de 14 de Shopify).
        // Regalo: cada 2 cajas (de cualquier color) el kit de clips y adhesivo; lo agrega el carrito (assets/srj-carrito.js).
        var cajasEnCarrito = 0, modo = 'unidad';
        var util = parseFloat(m2.dataset.util), cubre = parseFloat(m2.dataset.cubre), cajaN = parseInt(m2.dataset.cajaN, 10);
        var anchoIn = m2.querySelector('[data-srj-m2-ancho]');
        var formWpc = m2.closest('form');
        var idInput = formWpc ? formWpc.querySelector('[name="id"]') : null;
        var cajaId = m2.dataset.cajaId, cajaPrecio = parseInt(m2.dataset.cajaPrecio || '0', 10) / 100, cajaAntes = parseInt(m2.dataset.cajaAntes || '0', 10) / 100;
        var num = function (n, d) { return n.toLocaleString('es-UY', { minimumFractionDigits: d, maximumFractionDigits: d }); };
        var plata = function (n) { return '$U' + Math.round(n).toLocaleString('es-UY'); };
        var recalcularP = function () {
          var n = parseInt(m2Num.value, 10);
          if (isNaN(n) || n < 1) n = 1;
          m2Cant.value = n;
          var porCaja = modo === 'caja';
          var precio = porCaja ? cajaPrecio : m2Precio;
          if (idInput) idInput.value = porCaja ? cajaId : m2.dataset.unidadId;
          m2.querySelector('[data-srj-m2-total]').textContent = plata(n * precio);
          var cu = m2.querySelector('[data-srj-m2-cuota]');
          if (cu) cu.textContent = plata(n * precio / 12);
          var ah = m2.querySelector('[data-srj-m2-ahorro]');
          if (ah) ah.querySelector('[data-srj-m2-ahorro-n]').textContent = plata(n * (porCaja ? cajaAntes - cajaPrecio : parseInt(ah.dataset.antes, 10) / 100 - m2Precio));
          var paneles = porCaja ? n * cajaN : n;
          var pk = m2.querySelector('[data-srj-pack]');
          if (pk) {
            // cuentan también las cajas que ya están en el carrito (de cualquier color)
            var yaHay = cajasEnCarrito, tot = yaHay + (porCaja ? n : 0);
            var kits = Math.floor(tot / 2), ok = kits > 0;
            pk.classList.toggle('is-ok', ok);
            pk.querySelector('[data-srj-pack-barra]').style.width = Math.min(100, tot / 2 * 100) + '%';
            var previo = yaHay ? 'Con ' + (yaHay === 1 ? 'la caja' : 'las ' + yaHay + ' cajas') + ' que ya tenés en el carrito, ' : '';
            pk.querySelector('[data-srj-pack-txt]').innerHTML = ok
              ? previo + (previo ? 'i' : 'I') + 'ncluye de regalo: <b>' + (kits * 112) + ' clips y ' + kits + (kits === 1 ? ' adhesivo' : ' adhesivos') + '</b>.'
              : previo + (previo ? 't' : 'T') + 'e ' + (2 - tot === 1 ? 'falta 1 caja' : 'faltan 2 cajas') + '.';
            var ir = pk.querySelector('[data-srj-pack-ir]');
            var cajaBtn = m2.querySelector('[data-srj-modo="caja"]');
            ir.hidden = ok || !cajaBtn || cajaBtn.disabled; ir.textContent = 2 - yaHay === 1 ? 'Llevar 1 caja' : 'Llevar 2 cajas';
          }
          var cajas = Math.floor(paneles / cajaN), sueltos = paneles - cajas * cajaN;
          m2.querySelector('[data-srj-m2-detalle]').textContent = (porCaja ? n + (n === 1 ? ' caja = ' : ' cajas = ') + paneles + ' paneles: cubren ' : paneles + (paneles === 1 ? ' panel cubre ' : ' paneles cubren ')) +
            num(paneles * cubre, 1) + ' m² (' + num(paneles * util, 2) + ' m de ancho, hasta 2,90 m de alto)' +
            (!porCaja && cajas ? ' · equivale a ' + cajas + (cajas === 1 ? ' caja cerrada de ' : ' cajas cerradas de ') + cajaN + (sueltos ? ' + ' + sueltos + ' sueltos' : '') : '') + '.';
        };
        // Por unidad / Caja cerrada: al cambiar se conserva la cantidad de paneles (redondeando a cajas para arriba)
        var ponerModo = function (m, cantidad) {
          var antes = modo;
          modo = m;
          m2.querySelectorAll('[data-srj-modo]').forEach(function (b) { b.setAttribute('aria-checked', String(b.dataset.srjModo === m)); });
          m2.querySelector('[data-srj-m2-pregunta]').textContent = m === 'caja' ? '¿Cuántas cajas necesitás?' : '¿Cuántos paneles necesitás?';
          m2.querySelector('[data-srj-m2-unidad]').textContent = m === 'caja' ? 'cajas' : 'paneles';
          var n = parseInt(m2Num.value, 10) || 1;
          if (cantidad) m2Num.value = cantidad;
          else if (antes !== m) m2Num.value = m === 'caja' ? Math.max(1, Math.ceil(n / cajaN)) : n * cajaN;
          recalcularP();
        };
        anchoIn.addEventListener('input', function () {
          var w = parseFloat(String(anchoIn.value).replace(',', '.'));
          if (w > 0) {
            var p = Math.ceil(Math.round(w / util * 1e6) / 1e6);
            m2Num.value = modo === 'caja' ? Math.ceil(p / cajaN) : p;
            recalcularP();
          }
        });
        m2.addEventListener('click', function (e) {
          var b = e.target.closest('[data-srj-modo]');
          if (b) { ponerModo(b.dataset.srjModo); return; }
          if (e.target.closest('[data-srj-pack-ir]')) { ponerModo('caja', Math.max(1, 2 - cajasEnCarrito)); return; }
          if (e.target.closest('[data-srj-menos], [data-srj-mas]')) window.setTimeout(recalcularP, 0);
        });
        m2Num.addEventListener('input', recalcularP);
        m2Num.addEventListener('change', recalcularP);
        // cajas de WPC interior que ya están en el carrito (se actualiza cuando cambia el carrito)
        var leerCarrito = function (c) {
          cajasEnCarrito = (c.items || []).filter(function (it) { return (it.handle || '').indexOf('caja-wpc-interior-') === 0; }).reduce(function (s, it) { return s + it.quantity; }, 0);
          recalcularP();
        };
        fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(leerCarrito).catch(function () {});
        document.addEventListener('srj:carrito', function (e) { leerCarrito(e.detail); });
        recalcularP();
      } else {
      var recalcular = function () {
        var pide = parseInt(m2Num.value, 10);
        if (isNaN(pide) || pide < 1) pide = 1;
        var lleva = m2Margen.checked ? Math.ceil(Math.round(pide * 1.1 * 1e6) / 1e6) : pide;
        m2Cant.value = lleva;
        m2.querySelector('[data-srj-m2-total]').textContent = '$U' + Math.round(lleva * m2Precio).toLocaleString('es-UY');
        var cuotaM2 = m2.querySelector('[data-srj-m2-cuota]');
        if (cuotaM2) cuotaM2.textContent = '$U' + Math.round(lleva * m2Precio / 12).toLocaleString('es-UY');
        var ahorroM2 = m2.querySelector('[data-srj-m2-ahorro]');
        if (ahorroM2) ahorroM2.querySelector('[data-srj-m2-ahorro-n]').textContent = '$U' + Math.round(lleva * (parseInt(ahorroM2.dataset.antes, 10) / 100 - m2Precio)).toLocaleString('es-UY');
        m2.querySelector('[data-srj-m2-detalle]').textContent = 'Comprás ' + lleva + ' m²' + (m2Margen.checked ? ' (' + pide + ' + 10% para cortes)' : '') +
          ' · equivale a ' + (lleva / m2Caja).toFixed(1).replace('.', ',') + ' cajas. Vendemos los m² justos.';
      };
      // después de los botones − y + (que cambian el número en su propio clic)
      m2.addEventListener('click', function () { window.setTimeout(recalcular, 0); });
      m2Num.addEventListener('input', recalcular);
      m2Num.addEventListener('change', recalcular);
      m2Margen.addEventListener('change', recalcular);
      recalcular();
      }
    }

    // Reseñas destacadas: una por vez, sin desplazamiento (no se mueven al pasar el dedo); las flechas pasan de a una.
    // El recuadro toma el alto de la reseña más alta, así lo de abajo no sube y baja al cambiar.
    var dest = ficha.querySelector('[data-srj-dest]');
    if (dest) {
      var pistaD = dest.querySelector('[data-srj-dest-pista]');
      var nD = dest.querySelector('[data-srj-dest-n]');
      var antD = dest.querySelector('[data-srj-dest-ant]');
      var sigD = dest.querySelector('[data-srj-dest-sig]');
      var tarjetasD = [].slice.call(pistaD.children);
      var totalD = tarjetasD.length, iD = 0;
      var altoD = function () {
        var max = 0;
        tarjetasD.forEach(function (t) { t.classList.add('is-midiendo'); max = Math.max(max, t.offsetHeight); t.classList.remove('is-midiendo'); });
        if (max) pistaD.style.height = max + 'px';
      };
      var mostrarD = function (i) {
        iD = Math.max(0, Math.min(totalD - 1, i));
        tarjetasD.forEach(function (t, k) { t.classList.toggle('is-activa', k === iD); });
        nD.textContent = iD + 1; antD.disabled = iD === 0; sigD.disabled = iD === totalD - 1;
      };
      antD.addEventListener('click', function () { mostrarD(iD - 1); });
      sigD.addEventListener('click', function () { mostrarD(iD + 1); });
      window.addEventListener('resize', function () { window.requestAnimationFrame(altoD); });
      mostrarD(0);
      altoD();
      // las fotos de las tarjetas cargan después: se vuelve a medir
      pistaD.querySelectorAll('img').forEach(function (im) { if (!im.complete) im.addEventListener('load', altoD, { once: true }); });
      // Fotos de una reseña: se abren en grande, con flechas para pasar entre las de la misma reseña
      galeriaResenas(dest, '[data-srj-dest-visor]', '[data-srj-dest-img]', '[data-srj-dest-foto]', '[data-srj-dest-cerrar]');
    }

    // Opiniones de clientes: "Ver más" y fotos en grande
    var op = ficha.parentElement && ficha.parentElement.querySelector('[data-srj-op]') || ficha.querySelector('[data-srj-op]');
    if (op) {
      var masOp = op.querySelector('[data-srj-op-mas]');
      if (masOp) masOp.addEventListener('click', function () { op.classList.add('is-todas'); });
      galeriaResenas(op, '[data-srj-op-visor]', '[data-srj-op-img]', '[data-srj-op-foto]', '[data-srj-op-cerrar]');
    }

    // Barra fija de compra (celular, piso SPC)
    var barraC = ficha.querySelector('[data-srj-barra]');
    var precioC = ficha.querySelector('.srj-ficha__precio');
    var m2C = ficha.querySelector('[data-srj-m2]');
    if (barraC && precioC && m2C) {
      if (barraC.parentNode !== document.body) document.body.appendChild(barraC);
      var verBarra = function () {
        var celu = window.matchMedia('(max-width: 809.98px)').matches;
        var r = m2C.getBoundingClientRect();
        var on = celu && precioC.getBoundingClientRect().bottom < 0 && !(r.top < window.innerHeight && r.bottom > 0);
        barraC.classList.toggle('is-visible', on);
        document.body.classList.toggle('srj-barra-on', on);
      };
      barraC.querySelector('[data-srj-barra-ir]').addEventListener('click', function () { m2C.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
      window.addEventListener('scroll', verBarra, { passive: true });
      window.addEventListener('resize', verBarra);
      verBarra();
    }

    // Cantidad
    var numero = ficha.querySelector('.srj-cantidad__numero');
    var menos = ficha.querySelector('[data-srj-menos]');
    var mas = ficha.querySelector('[data-srj-mas]');
    if (numero) {
      var leer = function () { var n = parseInt(numero.value, 10); return isNaN(n) || n < 1 ? 1 : n; };
      if (menos) menos.addEventListener('click', function () { numero.value = Math.max(1, leer() - 1); });
      if (mas) mas.addEventListener('click', function () { numero.value = leer() + 1; });
      numero.addEventListener('change', function () { numero.value = leer(); });
    }

    // Columna de fotos pegajosa (compu): si es más alta que la pantalla, se pega por abajo en vez de por arriba
    var galS = ficha.querySelector('.srj-ficha__galeria');
    if (galS) {
      var ajustarGal = function () { galS.style.setProperty('--srj-gal-top', Math.min(90, window.innerHeight - galS.offsetHeight - 20) + 'px'); };
      ajustarGal();
      window.addEventListener('resize', ajustarGal);
      window.addEventListener('load', ajustarGal);
      if (window.ResizeObserver) new ResizeObserver(ajustarGal).observe(galS);
    }

    // Cuenta regresiva de entrega (hora de Uruguay).
    var cuenta = ficha.querySelector('[data-srj-cuenta]');
    if (cuenta) {
      var texto = cuenta.querySelector('[data-srj-cuenta-texto]');
      var barra = cuenta.querySelector('[data-srj-cuenta-barra]');
      // La regla de horarios está en assets/srj-entrega.js (la comparte el carrito).
      var calcular = function () {
        if (!window.srjEntrega) return;
        var e = window.srjEntrega();
        texto.textContent = e.texto;
        barra.style.width = e.avance + '%';
      };
      calcular();
      setInterval(calcular, 1000);
    }

    // Comprar ahora: agrega al carrito y va al pago.
    var ahora = ficha.querySelector('[data-srj-comprar-ahora]');
    var form = ficha.querySelector('form[data-type="add-to-cart-form"]');
    if (ahora && form) {
      ahora.addEventListener('click', function () {
        if (ahora.disabled) return;
        ahora.setAttribute('aria-busy', 'true');
        var datos = new FormData(form);
        var id = form.querySelector('[name="id"]').value;
        datos.set('id', id);
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body: datos,
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart');
            return (window.srjRegaloWpc ? window.srjRegaloWpc() : Promise.resolve()).then(function () { window.location.href = '/checkout'; });
          })
          .catch(function () { ahora.removeAttribute('aria-busy'); form.requestSubmit ? form.requestSubmit() : form.submit(); });
      });
    }

    // Preguntas frecuentes
    // Cerrada, cada pregunta mide lo que su texto (1 o 2 renglones) + el aire de arriba y abajo: la línea queda siempre a la misma distancia
    var altoFaq = function () {
      ficha.querySelectorAll('.srj-faq__item').forEach(function (item) {
        var t = item.querySelector('.srj-faq__texto');
        if (t) item.style.setProperty('--srj-faq-cerrada', Math.round(t.getBoundingClientRect().bottom - item.getBoundingClientRect().top + 19) + 'px');
      });
    };
    altoFaq();
    window.addEventListener('resize', altoFaq);
    ficha.querySelectorAll('.srj-faq__pregunta').forEach(function (boton) {
      boton.addEventListener('click', function () {
        var item = boton.closest('.srj-faq__item');
        var abrir = boton.getAttribute('aria-expanded') !== 'true';
        boton.setAttribute('aria-expanded', abrir ? 'true' : 'false');
        item.classList.toggle('is-abierta', abrir);
      });
    });
  }

  // Visor de fotos de reseñas: flechas, teclado (← →), deslizar en táctil y contador "1 / 2"
  function galeriaResenas(raiz, selVisor, selImg, selBoton, selCerrar) {
    var visor = raiz.querySelector(selVisor);
    if (!visor || typeof visor.showModal !== 'function') return;
    var img = visor.querySelector(selImg), ant = visor.querySelector('[data-g-ant]'), sig = visor.querySelector('[data-g-sig]'), n = visor.querySelector('[data-g-n]');
    var fotos = [], i = 0, x0 = null;
    var mostrarG = function () {
      img.src = fotos[i];
      var varias = fotos.length > 1;
      [ant, sig, n].forEach(function (el) { if (el) el.hidden = !varias; });
      if (n) n.textContent = (i + 1) + ' / ' + fotos.length;
      if (ant) ant.disabled = i === 0;
      if (sig) sig.disabled = i === fotos.length - 1;
    };
    var irG = function (d) { var k = i + d; if (k >= 0 && k < fotos.length) { i = k; mostrarG(); } };
    raiz.querySelectorAll(selBoton).forEach(function (b) {
      b.addEventListener('click', function () {
        fotos = (b.dataset.fotos || '').split('|').filter(Boolean);
        if (!fotos.length) fotos = [b.getAttribute(selBoton.slice(1, -1))];
        i = parseInt(b.dataset.i, 10) || 0;
        mostrarG();
        visor.showModal();
      });
    });
    if (ant) ant.addEventListener('click', function () { irG(-1); });
    if (sig) sig.addEventListener('click', function () { irG(1); });
    visor.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') irG(-1); if (e.key === 'ArrowRight') irG(1); });
    visor.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    visor.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) irG(dx < 0 ? 1 : -1);
    }, { passive: true });
    visor.querySelector(selCerrar).addEventListener('click', function () { visor.close(); });
    visor.addEventListener('click', function (e) { if (e.target === visor) visor.close(); });
    // al cerrar, el navegador devuelve el foco a la miniatura: se lo saca para que no quede marcada
    visor.addEventListener('close', function () { if (document.activeElement && document.activeElement.blur) document.activeElement.blur(); });
  }

  function todas() { document.querySelectorAll('.srj-ficha').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todas); else todas();
  document.addEventListener('shopify:section:load', todas);
})();
